import { render, staticRenderFns } from "./BiographyComponentItem.vue?vue&type=template&id=6453f9cc&scoped=true&"
import script from "./BiographyComponentItem.vue?vue&type=script&lang=js&"
export * from "./BiographyComponentItem.vue?vue&type=script&lang=js&"
import style0 from "./BiographyComponentItem.vue?vue&type=style&index=0&id=6453f9cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453f9cc",
  null
  
)

component.options.__file = "BiographyComponentItem.vue"
export default component.exports